import { useEffect, useMemo, useState, type RefObject } from 'react';

export default function useOnScreen(ref: RefObject<HTMLElement | null> | null) {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = useMemo(() => {
    return new IntersectionObserver(
      ([entry]) => setIntersecting(entry?.isIntersecting ?? false),
      {
        root: null,
        rootMargin: '0px',
        threshold: [0.8],
      },
    );
  }, []);

  useEffect(() => {
    if (ref?.current) {
      observer.observe(ref.current);
    }
    return () => observer?.disconnect();
  }, [observer, ref]);

  return isIntersecting;
}
